var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

import styles from "./About.css";

var Manifesto = function (_Component) {
  _inherits(Manifesto, _Component);

  function Manifesto() {
    _classCallCheck(this, Manifesto);

    return _possibleConstructorReturn(this, (Manifesto.__proto__ || Object.getPrototypeOf(Manifesto)).apply(this, arguments));
  }

  _createClass(Manifesto, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.aboutSections },
        React.createElement(
          "div",
          { className: styles.sectionHeaders },
          React.createElement(
            "h4",
            null,
            "The Axios Manifesto"
          )
        ),
        React.createElement(
          "div",
          { className: styles.aboutContent },
          React.createElement(
            "p",
            null,
            "All of us left cool, safe jobs to start a new company with this shared belief: Media is broken \u2014 and too often a scam."
          ),
          React.createElement(
            "p",
            null,
            "Stories are too long. Or too boring. Web sites are a maddening mess. Readers and advertisers alike are too often afterthoughts. They get duped by headlines that don't deliver and distracted by pop-up nonsense or unworthy clicks. Many now make money selling fake headlines, fake controversies and even fake news."
          ),
          React.createElement(
            "p",
            null,
            "Can you imagine Ford being obsessed mainly with whether the engineers love the howl and design of the F-150 engine, instead of simply delivering an awesome truck people want to drive? Never. But that's what digital media companies too often do. They produce journalism the way journalists want to produce it. And they design their products to maximize short-term buzz or revenue — not deliver the best experience possible."
          ),
          React.createElement(
            "p",
            null,
            "We are engineering Axios around a simple proposition: Deliver the cleanest, smartest, most efficient and trust-worthy experience for readers and advertisers alike."
          ),
          React.createElement(
            "p",
            null,
            "Our guiding principles include:"
          ),
          React.createElement(
            "p",
            null,
            React.createElement(
              "strong",
              null,
              "Reader first"
            )
          ),
          React.createElement(
            "p",
            null,
            "The data on what news readers want is unmistakable: content they can trust — delivered way, way more efficiently. No bias. No nonsense. Every piece of content we produce will be broken and narrated with true expertise - and then summarized in one shareable element. You can decide whether to go deeper. Often, there's no need. We have one agenda: help people get smarter, faster. So we designed our content to move seamlessly from our platform to other ecosystems, including Facebook and Apple News, to meet readers on their terms, not ours."
          ),
          React.createElement(
            "p",
            null,
            React.createElement(
              "strong",
              null,
              "Elegant efficiency"
            )
          ),
          React.createElement(
            "p",
            null,
            "Make reading, watching and listening as clean and reader-friendly as possible. This means killing everything from banner ads and pop-ups to topic pages and other web features designed for clicks, not usability. Our site eliminates traditional click-based pages AND allows you to view our content without leaving your stream of news. Our design guru, Alexis Lloyd, coined the term \"elegant efficiency\" to guide our every iteration."
          ),
          React.createElement(
            "p",
            null,
            React.createElement(
              "strong",
              null,
              "Smart, always"
            )
          ),
          React.createElement(
            "p",
            null,
            "Assume smart people want smart content — on our platform and beyond. Many don't want serious news and information. We focus only on those who do — and then resist all the traffic-based temptations to dumb things down. We have hired people with social media superpowers and asked them to quit using those powers to attract traffic for traffic’s sake, and instead use them as a force for good: Getting smart content in front of readers on our platforms and on Facebook, Apple News, LinkedIn and other social ecosystems."
          ),
          React.createElement(
            "p",
            null,
            React.createElement(
              "strong",
              null,
              "Don't sell BS"
            )
          ),
          React.createElement(
            "p",
            null,
            "It's hard to argue with a straight face that newspaper ads, or banners, or expensive, glossy native advertising programs are the most effective means for communicating. We developed a lower-cost, more measurable and adjustable way for advertisers to do native advertising within our platform AND within our content on Facebook. We want to work with advertisers so they feel they get awesome, measurable value — and the respect and return they deserve."
          ),
          React.createElement(
            "p",
            null,
            React.createElement(
              "strong",
              null,
              "Smart Brevity"
            )
          ),
          React.createElement(
            "p",
            null,
            "If you think about your evolving habits for consuming news and information, you realize you have less time, and a shorter attention span. Our content, our ads and our platforms are designed specifically to adjust to these new habits and demands. We aim to make the experience more substantive and meaningful \u2014 and therefore more valuable. When we pull this off, it will free people up to spend time on content truly WORTHY of their time, on our platform or elsewhere."
          ),
          React.createElement(
            "p",
            null,
            React.createElement(
              "strong",
              null,
              "Excellence always"
            )
          ),
          React.createElement(
            "p",
            null,
            "Media is a tough business. But it is a business, not a right, or charity or hobby. You distinguish yourself by delivering at a very high level on promises you make to news consumers, advertisers and subscribers. We believe life is simple: If we think big, deliver on our big promises, and show authentic appreciation for those who read and support us, we will be successful. So, thank you for reading this."
          )
        )
      );
    }
  }]);

  return Manifesto;
}(Component);

export default Manifesto;


// WEBPACK FOOTER //
// ./src/about/components/About/Manifesto.js